/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Clubs_Members_CountInputs */

const en_us2_clubs_members_count = /** @type {(inputs: Clubs_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Members: ${i?.count}`)
};

const pt_br2_clubs_members_count = /** @type {(inputs: Clubs_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membros: ${i?.count}`)
};

const es_419_clubs_members_count = /** @type {(inputs: Clubs_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miembros: ${i?.count}`)
};

const pt_pt2_clubs_members_count = /** @type {(inputs: Clubs_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membros: ${i?.count}`)
};

const fr_fr2_clubs_members_count = /** @type {(inputs: Clubs_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membres : ${i?.count}`)
};

const de_de2_clubs_members_count = /** @type {(inputs: Clubs_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mitglieder: ${i?.count}`)
};

const it_it2_clubs_members_count = /** @type {(inputs: Clubs_Members_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Membri: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Members: {count}" |
*
* @param {Clubs_Members_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_members_count = /** @type {((inputs: Clubs_Members_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Members_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_members_count(inputs)
	if (locale === "es-419") return es_419_clubs_members_count(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_members_count(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_members_count(inputs)
	if (locale === "de-DE") return de_de2_clubs_members_count(inputs)
	if (locale === "it-IT") return it_it2_clubs_members_count(inputs)
	return en_us2_clubs_members_count(inputs)
});
export { clubs_members_count as "clubs.members_count" }